import { create } from "zustand";
/**
 * Zustand store for managing modal state
 * Handles modal visibility, content type, and navigation history
 */
export const useModalStore = create(set => ({
    isOpen: false,
    contentType: null,
    history: [],
    setB3ModalOpen: isOpen => set({ isOpen }),
    setB3ModalContentType: content => set(state => {
        // Add current modal to history before changing
        const newHistory = state.contentType ? [...state.history, state.contentType] : state.history;
        return {
            contentType: content,
            history: newHistory,
        };
    }),
    navigateBack: () => set(state => {
        if (state.history.length === 0) {
            return { isOpen: false, contentType: null };
        }
        const newHistory = [...state.history];
        const previousModal = newHistory.pop();
        return {
            contentType: previousModal || null,
            history: newHistory,
        };
    }),
    clearHistory: () => set({ history: [] }),
    ecoSystemAccountAddress: undefined,
    setEcoSystemAccountAddress: (address) => set({ ecoSystemAccountAddress: address }),
    isLinking: false,
    linkingMethod: null,
    setLinkingState: (isLinking, method = null) => set({ isLinking, linkingMethod: isLinking ? method : null }),
    setClosable: (closable) => set(state => ({
        contentType: state.contentType ? { ...state.contentType, closable } : null,
    })),
    personaActive: false,
    setPersonaActive: (active) => set({ personaActive: active }),
}));
